import { render, staticRenderFns } from "./TheCourseTitleList.vue?vue&type=template&id=59837bb0&"
import script from "./TheCourseTitleList.vue?vue&type=script&lang=ts&"
export * from "./TheCourseTitleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports